import { createStore, applyMiddleware } from 'redux';
import TicketingSystemsReducer from '../reducers/TicketingSystemsReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(TicketingSystemsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
